/* eslint-disable */
import axios from "axios";
import getters from '../getters'

// Módulo para obtener buses
const baseUrl = process.env.VUE_APP_BASE_API + "/excursion/bookings/";

const state = {
  bookingsUnassigned: [],
  bookingsOrphanGroup: [], // bookings that do not have activity group assigned yet
  hasBookingsUnassigned: false,
  hasBookingsOrphanGroup: false,
  hasBookingsUnchecked: false,
  bookingsByActivity: [],
  bookingsByActivityForCheck: [],
  bookingsByExcursionBus: [],
  bookingsByPickupBus: [],
  bookingsByReturnBus: [],
  bookingsByStop: [],
  bookingsByPickupzoneSummary: [],
};

const actions = {
  // Cargar bookings sin parada
  loadBookingsUnassigned({
    commit
  }, data) {
    
    if ( data == undefined || (data !== undefined && data.no_booking_loading == false ) ) {
      commit("RESET_UNASSIGNED_BOOKINGS")
      commit("ISLOADING", ["booking", true], {root: true,});
    }
      
    axios
      .get(
        baseUrl + "list_unassigned_stops/" + 
        "?day=" + this.getters.filterDate + 
        "&activity_group=" + this.getters.filterGroup
      )
      .then(r => r.data)
      .then(bookingsUnassigned => {
        commit("SET_BOOKINGS_UNASSIGNED", bookingsUnassigned);
        commit("PROPOSE_STOP_UNASSIGNED_BOOKINGS", this.getters.stops)
        commit("ISLOADING", ["booking", false], {root: true,});
      });
  },
  loadOrphanBookings({
    commit
  }, data) {
    //commit("RESET_ORPHAN_BOOKINGS")
    if ( data == undefined || (data !== undefined && data.no_booking_loading == false ) )
      commit("ISLOADING", ['orphan_bookings', true], {root: true})
    axios
      .get(
        baseUrl + "list_orphan_bookings/" +
        "?day=" + this.getters.filterDate
      )
      .then(r => r.data)
      .then(orphan => {
        commit("SET_ORPHAN_BOOKINGS", orphan)
        commit("PROPOSE_ACTIVITY_GROUP_ORPHAN_BOOKINGS", this.getters.groups)
        commit("ISLOADING", ['orphan_bookings', false], {root: true})
      })
  },
  hasBookingsUnassigned({
    commit
  }) {
    axios
      .get(
        baseUrl + "bookings_without_stop/" + 
        "?day=" + this.getters.filterDate + 
        "&activity_group=" + this.getters.filterGroup
      )
      .then(r => r.data)
      .then(hasUnassigned => {
        commit("SET_HAS_BOOKINGS_UNASSIGNED", hasUnassigned.count)
      })
  },
  hasBookingsOrphanGroup({
    commit
  }) {
    axios
      .get(
        baseUrl + "bookings_orphan_group/" + 
        "?day=" + this.getters.filterDate
      )
      .then(r => r.data)
      .then(hasOrphan => {
        commit("SET_HAS_BOOKINGS_ORPHAN_GROUP", hasOrphan.count)
      })
  },
  hasBookingsUnchecked({
    commit
  }) {
    axios
      .get(
        baseUrl + "has_unchecked_bookings/" +
        "?day=" + this.getters.filterDate + 
        "&activity_group=" + this.getters.filterGroup
      )
      .then( response => {
        commit("SET_HAS_BOOKINGS_UNCHECKED", response.data.count)
      })
  },
  // Cargar reservas agrupadas por excursión/actividad
  loadBookingsByActivity({
    commit,
    getters,
    dispatch
  }) {
    commit("ISLOADING", ["booking", true], {
      root: true,
    });
    axios
      .get(
        baseUrl +
        "list_by_groups_activities/" + 
        "?day=" + this.getters.filterDate +
        "&activity_group=" + this.getters.filterGroup
      )
      .then(r => r.data)
      .then(bookingsByActivity => {
        commit("SET_BOOKINGS_BY_ACTIVITY", bookingsByActivity);
        commit("ISLOADING", ["booking", false], {
          root: true,
        });
      });   
    
  },
  // Cargar reservas agrupadas por bus
  loadBookingsByExcursionBus({
    commit
  }) {
    commit("ISLOADING", ["booking", true], {
      root: true,
    });
    axios
      .get(
        baseUrl +
        "list_by_bus/" + 
        "?day=" + this.getters.filterDate +
        "&bus_type=Excursion" +
        "&activity_group=" + this.getters.filterGroup
      )
      .then(r => r.data)
      .then(bookingsByExcursionBus => {
        commit("SET_BOOKINGS_BY_EXCURSION_BUS", bookingsByExcursionBus);
        commit("ISLOADING", ["booking", false], {
          root: true,
        });
        // commit("ISLOADING", ["booking", false], {
        //   root: true,
        // });
      });
  },
  loadBookingsByPickupBus({
    commit
  }) {
    commit("ISLOADING", ["booking", true], {
      root: true,
    });
    axios
      .get(
        baseUrl + "list_by_bus/" + 
        "?day=" + this.getters.filterDate +
        "&bus_type=Pickup" +
        "&activity_group=" + this.getters.filterGroup
      )
      .then(r => r.data)
      .then(bookingsByPickupBus => {
        commit("SET_BOOKINGS_BY_PICKUP_BUS", bookingsByPickupBus);
        commit("ISLOADING", ["booking", false], {
          root: true,
        });
      });
  },

  loadBookingsByReturnBus({
    commit
  }) {
    commit("ISLOADING", ["booking", true], {
      root: true,
    });
    axios
      .get(
        baseUrl + "list_by_bus/" + 
        "?day=" + this.getters.filterDate +
        "&bus_type=Return" +
        "&activity_group=" + this.getters.filterGroup
      )
      .then(r => r.data)
      .then(bookingsByReturnBus => {
        commit("SET_BOOKINGS_BY_RETURN_BUS", bookingsByReturnBus);
        commit("ISLOADING", ["booking", false], {
          root: true,
        });
      });
  },

  // Cargar reservas agrupadas por  parada
  loadBookingsByStop({
    commit
  }, payload) {
    commit("ISLOADING", ["booking", true], {
      root: true,
    });
    let bookingData = {}
    if ( payload ) {
      bookingData = payload
    } else {
      bookingData = {
        order: "&order=order" // default ordering
      }
    }
    let bus_type = 'Excursion'
    if ( this.getters.activeTab == 'Pickups' )
      bus_type = 'Pickup'
    else if ( this.getters.activeTab == 'Returns' )
      bus_type = 'Return'
    axios
      .get(
        baseUrl +
        "list_by_stop_schedule_order/" + 
        "?day=" + this.getters.filterDate +
        "&bus_type=" + bus_type + 
        "&activity_group=" + this.getters.filterGroup +
        (typeof bookingData.order == "undefined" ? "" : bookingData.order)
      )
      .then(r => r.data)
      .then(bookingsByStop => {
        commit("SET_BOOKINGS_BY_STOP", bookingsByStop);
        commit("ISLOADING", ["booking", false], {
          root: true,
        });
      });
  },
  // Cargar reservas agrupadas por excursión/actividad ordenadas
  loadBookingsByActivityOrdered({
    commit, dispatch
  }, bookingData) {
    commit("ISLOADING", ["booking", true], {
      root: true,
    });
    const exclude_no_bus_excursion_service = bookingData.exclude_no_bus_excursion_service // == null ? 'True' : 'False'
    const exclude_no_bus_pickup_service = bookingData.exclude_no_bus_pickup_service // == null ? 'True': 'False'
    const distinct_key = bookingData.distinct_key
    axios
      .get(
        baseUrl + "list_by_groups_activities/" +
        "?day=" + this.getters.filterDate +
        "&activity_group=" + this.getters.filterGroup +
        (bookingData.order_by == null ? '' : "&order_by=" + bookingData.order_by) +
        (exclude_no_bus_pickup_service == null ? '' : '&exclude_no_bus_pickup_service=' + exclude_no_bus_pickup_service) + 
        (exclude_no_bus_excursion_service == null ? '' : '&exclude_no_bus_excursion_service=' + exclude_no_bus_excursion_service) + 
        (distinct_key != null && distinct_key == 'tag' ? '&distinct_key=tag' : '')
        //"&exclude_no_bus_excursion_service=" + (exclude_no_bus_excursion_service == null ? '' : exclude_no_bus_excursion_service) + 
        //"&exclude_no_bus_pickup_service=" + 
      )
      .then(bookingsByActivity => {
        commit("SET_BOOKINGS_BY_ACTIVITY", bookingsByActivity.data);
        commit("ISLOADING", ["booking", false], {
          root: true,
        });
      });
  },

  loadBookingsByActivityForCheckingOrdered({
    commit, dispatch
  }, bookingData) {
    // function to get bookings grouped by activity ready to show list to be checked in frontend
    if ( bookingData.loader == null || bookingData.loader )
      commit("ISLOADING", ['checking_bookings', true], {root: true})
    const exclude_no_bus_excursion_service = bookingData.exclude_no_bus_excursion_service // == null ? 'True' : 'False'
    const exclude_no_bus_pickup_service = bookingData.exclude_no_bus_pickup_service // == null ? 'True': 'False'
    axios
      .get(
        baseUrl + "list_by_groups_activities/" +
        "?day=" + this.getters.filterDate +
        "&activity_group=" + this.getters.filterGroup +
        "&order_by=" + bookingData.order_by +
        (exclude_no_bus_pickup_service == null ? '' : '&exclude_no_bus_pickup_service=' + exclude_no_bus_pickup_service) + 
        (exclude_no_bus_excursion_service == null ? '' : '&exclude_no_bus_excursion_service=' + exclude_no_bus_excursion_service) 
      )
      .then(bookingsByActivity => {
        commit("SET_BOOKINGS_BY_ACTIVITY_FOR_CHECKING", bookingsByActivity.data);
        dispatch("hasBookingsUnchecked")
      })
      .finally(() => {
        if ( bookingData.loader == null || bookingData.loader )
          commit("ISLOADING", ['checking_bookings', false], {root: true})
      })
  },


  // Cargar reservas agrupadas por  bus ordenadas
  loadBookingsByBusOrdered({
    commit
  }, payload) {
    commit("ISLOADING", ["booking", true], {
      root: true,
    });
    const bus_type = this.getters.activeTab == 'Excursions' ? 'Excursion' : 'Pickup'
    let bookingData = {}
    if ( payload ) {
      bookingData = payload
      if ( !payload.bus_type ) {
        bookingData.bus_type = bus_type  // in case no bus_type -> set default based on active tab
      }
    } else {
      // no payload provided -> set default values to build request
      bookingData = {
        order_by: this.getters.activeTab == 'Excursions' ? "&order_by=booking__order_1" : "&order_by=booking__order", // default ordering
        bus_type: this.getters.activeTab == 'Excursions' ? 'Excursion' : 'Pickup'
      }
    }
    axios
      .get(
        baseUrl + "list_by_bus/" + 
        "?day=" + this.getters.filterDate +
        "&activity_group=" + this.getters.filterGroup +
        "&bus_type=" +  bookingData.bus_type +
        "&order_by=" + bookingData.order_by
      )
      .then(r => r.data)
      .then(bookingsByBus => {
        commit(bookingData.bus_type == "Pickup" ? "SET_BOOKINGS_BY_PICKUP_BUS" : "SET_BOOKINGS_BY_EXCURSION_BUS", bookingsByBus);
        commit("ISLOADING", ["booking", false], {
          root: true,
        });
      });
  },

  // Cargar reservas agrupadas por  bus ordenadas
  loadBookingsByStopOrdered({
    commit
  }, bookingData) {
    commit("ISLOADING", ["booking", true], {
      root: true,
    });
    //// const bus_type = this.getters.activeTab == 'Excursions' ? 'Excursion' : 'Pickup' // WARNING!! check if this changes is correct or not
    let bus_type = 'Excursion'
    if ( this.getters.activeTab == 'Pickups' )
      bus_type = 'Pickup'
    else if ( this.getters.activeTab == 'Returns' )
      bus_type = 'Return'
    const exclude_no_bus_pickup_service = bookingData.exclude_no_bus_pickup_service == null ? 'True' : 'False'
    axios
      .get(
        baseUrl + "list_by_stop_schedule_order/" +
        "?day=" + this.getters.filterDate +
        "&activity_group=" + this.getters.filterGroup +
        "&bus_type=" + bus_type +
        (bookingData.common_id == null || bookingData.common_id == "0" ? "" : "&common_id=" + bookingData.common_id) +
        "&order_by=" + bookingData.order_by + 
        (typeof bookingData.order == "undefined" ? "" : bookingData.order)
      )
      .then(r => r.data)
      .then(bookingsByStop => {
        commit("SET_BOOKINGS_BY_STOP", bookingsByStop);
        commit("ISLOADING", ["booking", false], {
          root: true,
        });
      });
  },

  resetBookingsUnassignedList({
    commit
  }) {
    commit("RESET_UNASSIGNED_BOOKINGS");
  },

  resetBookingsOrphanGroupList({
    commit
  }) {
    commit("RESET_ORPHAN_BOOKINGS");
  },

  // FIXME: DEPRECATED?
  deleteBookingsUnassigned({
    commit,
    getters,
    dispatch
  }, payload) {
    commit("DELETE_BOOKING_UNASSIGNED", payload.id);

    if ( this.getters.activeTab === 'Excursions') {
      dispatch("bookings/loadBookingsByActivity", { root: true })
    } else if ( this.getters.activeTab === 'Pickups') {
      dispatch("bookings/loadBookingsByExcursionBus", { root: true } )
      dispatch("bookings/loadBookingsByPickupBus", { root: true } )
    }
  },

  deleteBookingsOrphan({
    commit,
    getters,
    dispatch
  }, payload) {
    commit("DELETE_BOOKING_ORPHAN", payload.id);

    if ( this.getters.activeTab === 'Excursions') {
      dispatch("bookings/loadBookingsByActivity", { root: true })
    } else if ( this.getters.activeTab === 'Pickups') {
      dispatch("bookings/loadBookingsByExcursionBus", { root: true } )
      dispatch("bookings/loadBookingsByPickupBus", { root: true } )
    }
  },

  async patchBooking({
    commit,
    dispatch,
    getters,
    state
  }, payload) {

    // update booking with backend request
    await axios
      .patch(baseUrl + payload.booking.id + '/edit_booking/', payload.data)
      .then(response => {
        console.log('patch updateBooking', response.data)
      })
      .catch(response => {
        console.log('something wrong happened', response.data)
      })

    // reload data from backend after updating booking data
    dispatch("loadBookingsByExcursionBus")
    if (this.getters.activeTab == "Excursions") {
      dispatch("loadBookingsByActivityOrdered", {order_by: 'booking__order_1,customer_language'})
    } else if (this.getters.activeTab == 'Pickups') {
      dispatch("loadBookingsByStop")
      dispatch("loadBookingsByPickupBus")
    } else if ( this.getters.activeTab == "Check" ) {
      dispatch("loadBookingsByActivityForCheckingOrdered", {order_by: 'id,customer_language', loader: false})
    }
  },

  async pickupzoneSummary({
      commit, dispatch
  }) {
      await axios
          .get(
              baseUrl + 'bookings_by_pickupzone_summary/' + 
              '?day=' + this.getters.filterDate + 
              '&activity_group_id=' + this.getters.filterGroup + 
              '&suprazone_id=' + this.getters.filterSuprazone
          ).then( response => {
            commit('SET_BOOKINGS_BY_PICKUP_SUMMARY', response.data)
            // reload data to refresh UI
            //dispatch("buses/loadExcursionBuses", {}, { root: true })
            //dispatch("buses/loadPickupBuses", {}, { root: true})
          })
  },
    // Assign a stop to a booking
  async assignActivityGroup({
    commit,
    getters,
    dispatch
  }, payload) {
    // commit("ISLOADING", ["default", true], {
    //   root: true,
    // });
    await axios
      .patch(baseUrl + payload.id + "/assign_activity_group/", payload.data)
      .then(response => {
          commit("bookings/DELETE_BOOKING_ORPHAN", payload.id, {root: true})
          //dispatch("loadBookingsUnassigned", {no_booking_loading: true})
          // commit("ISLOADING", ["default", false], {
          //     root: true,
          // });
        },
        err => {
            console.log(err);
        }
      )
  },
  async toggleBusService({
    commit, dispatch
  }, payload) {
    await axios
      .patch(baseUrl + payload.id + "/toggle_bus_service/", payload)
      .then( response => {
        if ( this.getters.activeTab == 'Unassigned' || this.getters.activeTab == 'Orphan' ) {
          dispatch("loadBookingsUnassigned", {no_booking_loading: true})
          dispatch("loadOrphanBookings", {no_booking_loading: true})
        }
        else if ( this.getters.activeTab == 'Excursions' && this.getters.activeOption != 'NoService' ) {
          dispatch("bookings/loadBookingsByActivityOrdered", {order_by: 'booking__order_1,customer_language'}, {root: true})
        } else if ( this.getters.activeTab == 'Pickups' && this.getters.activeOption != 'NoService' ) {
          dispatch("bookings/loadBookingsByActivityOrdered", {order_by: 'booking__order_1,customer_language', exclude_no_bus_pickup_service: 'True'}, {root: true})
        }
        else if ( this.getters.activeOption == 'NoService') {
          if ( this.getters.activeTab == 'Excursions') {
            dispatch("bookings/loadBookingsByActivityOrdered", {order_by: 'booking__order_1,customer_language', exclude_no_bus_excursion_service: 'False'}, {root: true})
          } else if (this.getters.activeTab == 'Pickups') {
            dispatch("bookings/loadBookingsByActivityOrdered", {order_by: 'booking__order_1,customer_language', exclude_no_bus_pickup_service: 'False'}, {root: true})
          }
        }
      })
  },
  async modifyBusService({
    commit, dispatch
  }, payload) {
    return axios
      .patch(baseUrl + payload.id + "/modify_bus_service/", payload.data)
      .then( response => {
        if ( this.getters.activeTab == 'Unassigned' || this.getters.activeTab == 'Orphan' ) {
          dispatch("loadBookingsUnassigned", {no_booking_loading: true})
          dispatch("loadOrphanBookings", {no_booking_loading: true})
        }
        else if ( this.getters.activeTab == 'Excursions' && this.getters.activeOption != 'NoService' ) {
          dispatch("bookings/loadBookingsByActivityOrdered", {order_by: 'booking__order_1,customer_language'}, {root: true})
        } else if ( this.getters.activeTab == 'Pickups' && this.getters.activeOption != 'NoService' ) {
          dispatch("bookings/loadBookingsByActivityOrdered", {order_by: 'booking__order_1,customer_language', exclude_no_bus_pickup_service: 'True'}, {root: true})
        }
        else if ( this.getters.activeOption == 'NoService') {
          if ( this.getters.activeTab == 'Excursions') {
            dispatch("bookings/loadBookingsByActivityOrdered", {order_by: 'booking__order_1,customer_language', exclude_no_bus_excursion_service: 'False'}, {root: true})
          } else if (this.getters.activeTab == 'Pickups') {
            dispatch("bookings/loadBookingsByActivityOrdered", {order_by: 'booking__order_1,customer_language', exclude_no_bus_pickup_service: 'False'}, {root: true})
          }
        }
      })
  },
  async editBookingActivityDurationType({
    commit, dispatch
  }, payload ) {
    await axios
      .patch( baseUrl + "/edit_bulk_activity_duration_type/", payload)
      .then( response => {

      })
  },
  async archive({
    commit, dispatch
  }, payload) {
    await axios
      .patch( baseUrl + payload.id + "/archive/")
      .then( respone => {
        if ( this.getters.activeTab == 'Unassigned' || this.getters.activeTab == 'Orphan' ) {
          dispatch("loadBookingsUnassigned", {no_booking_loading: true})
          dispatch("loadOrphanBookings", {no_booking_loading: true})
        }
        else if ( this.getters.activeTab == 'Excursions' && this.getters.activeOption != 'NoService' ) {
          dispatch("bookings/loadBookingsByActivityOrdered", {order_by: 'booking__order_1,customer_language'}, {root: true})
        } else if ( this.getters.activeTab == 'Pickups' && this.getters.activeOption != 'NoService' ) {
          dispatch("bookings/loadBookingsByActivityOrdered", {order_by: 'booking__order_1,customer_language', exclude_no_bus_pickup_service: 'True'}, {root: true})
        }
        else if ( this.getters.activeOption == 'NoService') {
          if ( this.getters.activeTab == 'Excursions') {
            dispatch("bookings/loadBookingsByActivityOrdered", {order_by: 'booking__order_1,customer_language', exclude_no_bus_excursion_service: 'False'}, {root: true})
          } else if (this.getters.activeTab == 'Pickups') {
            dispatch("bookings/loadBookingsByActivityOrdered", {order_by: 'booking__order_1,customer_language', exclude_no_bus_pickup_service: 'False'}, {root: true})
          }
        }
      })
  },
  async toggleCheckedFlag({
    commit, dispatch
  }, payload) {
    await axios
      .patch( baseUrl + payload.id + "/toggle_checked_flag/")
      .then( response => {
        // let booking = this.state.bookingsByActivityForCheck.find( (item) => item.id == payload.id)
        // booking.checked = !booking.checked

        this._vm.$notify({
          group: "foo",
          title: "Check cambiado",
          text: "Reserva gestionada correctamente",
          type: "success"
        });
      })
      .catch( error => {
        this._vm.$notify({
          group: "foo",
          title: "Chequeo incorrecto",
          text: "No se ha podido cambiar el estado del chequeo de la reserva",
          type: "error"
        });
        console.log(error)
      })
      .finally( () => {
        dispatch("hasBookingsUnchecked")
      })
  }
};




const mutations = {
  SET_BOOKINGS_UNASSIGNED(state, bookingsUnassigned) {
    state.bookingsUnassigned = bookingsUnassigned;
  },
  PROPOSE_STOP_UNASSIGNED_BOOKINGS(state, stops) {
    for ( let booking of state.bookingsUnassigned ) {
      try {
        if ( booking.stop == undefined ) {
          // apply similarity computing between pickup point provided by trekk and the list of stops from getter
          console.log('apply similarity')
          let stringSimilarity = require("string-similarity");
          const stopNames = this.getters.stops.map( (stop) => stop.geo_point.name.toLowerCase())
          console.log('compare with', booking.pickup_point_trekk)
          const ratings = stringSimilarity.findBestMatch(booking.pickup_point_trekk.toLowerCase(), stopNames)
          console.log('ratings', ratings)
          if ( ratings.bestMatch != null && ratings.bestMatch.rating > 0.5) {
            const index = ratings.bestMatchIndex
            booking.value = this.getters.stops[index].id
            console.log('booking value', booking.value)
          }

          // const stop = this.getters.stops.find( el => el.geo_point.name == booking.pickup_point_trekk)
          // if ( stop !== undefined ) {
          //   booking.value = stop.id
          // }
        }
      } catch ( e ) {
        console.log(e)
      }
    }
  },
  SET_ORPHAN_BOOKINGS(state, orphanBookings) {
    state.bookingsOrphanGroup = orphanBookings
  },
  PROPOSE_ACTIVITY_GROUP_ORPHAN_BOOKINGS(state, groups) {
    // propose for orphan group an activity group (if it is possible)
    for ( let booking of state.bookingsOrphanGroup ) {
      if ( booking.value == undefined ) {
        // no value set, infer from pickup time or start time
        const time = booking.pickup_hour_trekk
        const start = booking.trekksoft_availability_item_start
        try {
          let parsed = undefined
          if ( start.includes(':') ) {
            // test with start time
            const split = start.split(':')
            parsed = parseInt(split[0])
          }
          else if ( time.includes(':') ) { 
            // test with pickup our
            const split = time.split(':')
            parsed = parseInt(split[0])
          }

          if ( parsed !== undefined ) {
            if ( parsed < 11 ) {
              // mañanas
              const group = this.getters.groups.filter((it) => it.manage == true).filter(el => el.name.toLowerCase().includes('mañana'))
              if ( group.length == 1)
                booking.value = group[0].id
            } else if ( parsed > 11 && parsed < 17) {
              const group = this.getters.groups.filter((it) => it.manage == true).filter(el => el.name.toLowerCase().includes('tarde'))
              if ( group.length == 1)
                booking.value = group[0].id
            } else if ( parsed > 17 ) {
              const group = this.getters.groups.find(el => el.name = 'Noche')
              booking.value = group.id
            }
          }
        } catch ( e ) {}
      }
    }
  },
  SET_HAS_BOOKINGS_UNASSIGNED(state, count) {
    state.hasBookingsUnassigned = count > 0 ? true : false
  },
  SET_HAS_BOOKINGS_ORPHAN_GROUP(state, count) {
    state.hasBookingsOrphanGroup = count > 0 ? true : false
  },
  SET_HAS_BOOKINGS_UNCHECKED(state, count) {
    state.hasBookingsUnchecked = count > 0 ? true : false
  },

  SET_BOOKINGS_BY_ACTIVITY(state, bookingsByActivity) {
    state.bookingsByActivity = bookingsByActivity
  },

  SET_BOOKINGS_BY_ACTIVITY_FOR_CHECKING(state, bookings) {
    state.bookingsByActivityForCheck = bookings
  },

  SET_BOOKINGS_BY_EXCURSION_BUS(state, bookingsByExcursionBus) {
    state.bookingsByExcursionBus = bookingsByExcursionBus;
  },
  SET_BOOKINGS_BY_PICKUP_BUS(state, bookingsByPickupBus) {
    state.bookingsByPickupBus = bookingsByPickupBus;
  },
  SET_BOOKINGS_BY_RETURN_BUS(state, bookingsByReturnBus) {
    state.bookingsByReturnBus = bookingsByReturnBus;
  },
  SET_BOOKINGS_BY_STOP(state, bookingsByStop) {
    state.bookingsByStop = bookingsByStop;
  },
  SET_BOOKINGS_BY_PICKUP_SUMMARY(state, data) {
    state.bookingsByPickupzoneSummary = data
  },

  ADD_BOOKING: (state, {
    bookingData
  }) => {
    state.bookingsByActivity.push(bookingData);
    //state.bookingsByBus.push(bookingData);
  },

  UPDATE_BOOKING_BY_ACTIVITY: (state, {
    bookingData, busType, operation=''
  }) => {
    for (let i = 0; i < state.bookingsByActivity.length; i++) {
      const bookingsByActivity = state.bookingsByActivity[i];
      let list = bookingsByActivity.bookings_list;
      for (let j = 0; j < list.length; j++) {
        let booking = list[j];
        if (booking.id == bookingData.id) {
          // booking before updating data
          let editBooking = bookingsByActivity.bookings_list[j]
          state.bookingsByActivity[i].bookings_list.splice(j, 1, bookingData);
          // update remaining pax by activity
          let n = bookingData.customer_adults + bookingData.customer_children
          if ( editBooking.bookingrelbus_set.length == 2 && operation === 'assign_bus' ) {
            // if booking has been assigned to both buses, don't touch unassigned totals
            break;
          } else if ( editBooking.bookingrelbus_set.length == 1 && editBooking.bookingrelbus_set[0].bus_type_rel.type == busType && operation == 'assign_bus' ) {
            // if booking has been already assigned to the same bus type to which now user is assigning, break and don't touch unassigned totals
            break;
          }
          let book = 1
          if ( operation === 'assign_bus' ) {
            n = n * -1
            book = book * -1
          }
          state.bookingsByActivity[i].count_unassigned_customers = state.bookingsByActivity[i].count_unassigned_customers + n
          state.bookingsByActivity[i].count_unassigned_bookings = state.bookingsByActivity[i].count_unassigned_bookings + book
          break
        }
      }
      
    }
  },

  UPDATE_BOOKING_BY_BUS: (state, {
    bookingData,
    isPickup,
    busType,
    operation = '',
  }) => {
    let currentBookings = isPickup ? state.bookingsByPickupBus : state.bookingsByExcursionBus;
    for (let i = 0; i < currentBookings.length; i++) {
      const current = currentBookings[i];
      let list = current.bookings_list;
      for (let j = 0; j < list.length; j++) {
        let booking = list[j];
        if (booking.id == bookingData.id) {
          let editBooking = current.bookings_list[j]
          
          let n = bookingData.customer_adults + bookingData.customer_children
          if ( editBooking.bookingrelbus_set.length == 2 && operation === 'assign_bus' ) {
            // if booking has been assigned to both buses, don't touch unassigned totals
            break;
          } else if ( editBooking.bookingrelbus_set.length == 1 && editBooking.bookingrelbus_set[0].bus_type_rel.type == busType && operation == 'assign_bus' ) {
            // if booking has been already assigned to the same bus type to which now user is assigning, break and don't touch unassigned totals
            break;
          }
          let book = 1
          if ( operation === 'assign_bus' ) {
            n = n * -1
            book = book * -1
            currentBookings[i].bookings_list.splice(j, 1, bookingData);
          }
          else if ( operation === 'deassign_bus' ) {
            currentBookings[i].bookings_list.splice(j, 1);
          }
          currentBookings[i].count_unassigned_customers = currentBookings[i].count_unassigned_customers + n
          currentBookings[i].count_unassigned_bookings = currentBookings[i].count_unassigned_bookings + book
          break
        }
      }
    }
  },

  UPDATE_BOOKING_BY_STOP: (state, {
    bookingData,
    busType,
    operation = ''
  }) => {
    for (let i = 0; i < state.bookingsByStop.length; i++) {
      const bookingsByStop = state.bookingsByStop[i];
      let list = bookingsByStop.bookings_list;
      for (let j = 0; j < list.length; j++) {
        let booking = list[j];
        if (booking.id == bookingData.id) {
          let editBooking = bookingsByStop.bookings_list[j]
          state.bookingsByStop[i].bookings_list.splice(j, 1, bookingData);
          let n = bookingData.customer_adults + bookingData.customer_children
          console.log('editBooking', editBooking)

          if ( operation == 'assign_bus' ) {
            const findOld = editBooking.bookingrelbus_set.find( (item) => item.bus_type_rel.type == busType)
            const findNew = bookingData.bookingrelbus_set.find( (item) => item.bus_type_rel.type == busType)
            if ( findOld !== undefined && findNew !== undefined ) 
              break
          }

          // if ( editBooking.bookingrelbus_set.length == 3 && operation === 'assign_bus' ) {
          //   // if booking has been assigned to three buses, don't touch unassigned totals
          //   break;
          // } else if ( editBooking.bookingrelbus_set.length == 1 && editBooking.bookingrelbus_set[0].bus_type_rel.type == busType && operation == 'assign_bus' ) {
          //   // if booking has been already assigned to the same bus type to which now user is assigning, break and don't touch unassigned totals
          //   break;
          // }
          let book = 1
          if ( operation === 'assign_bus' ) {
            n = n * -1
            book = book * -1
          }
          state.bookingsByStop[i].count_unassigned_customers = state.bookingsByStop[i].count_unassigned_customers + n
          state.bookingsByStop[i].count_unassigned_bookings = state.bookingsByStop[i].count_unassigned_bookings + book
          break
        }
      }
    }
  },

  UPDATE_BOOKINGS_BY_ACTIVITY: (state, {
    bookingData
  }) => {
    for (let i = 0; i < bookingData.length; i++) {
      const element = bookingData[i];

      for (let i = 0; i < state.bookingsByActivity.length; i++) {
        const bookingByActivity = state.bookingsByActivity[i];
        let list = bookingByActivity.bookings_list;
        for (let j = 0; j < list.length; j++) {
          let booking = list[j];
          if (booking.id == element.id) {
            state.bookingsByActivity[i].bookings_list.splice(j, 1, element);
          }
        }
      }
    }
  },

  UPDATE_BOOKINGS_BY_BUS: (state, {
    bookingData
  }) => {
    for (let i = 0; i < bookingData.length; i++) {
      const element = bookingData[i];

      for (let i = 0; i < state.bookingsByBus.length; i++) {
        const bookingsByBus = state.bookingsByBus[i];
        let list = bookingsByBus.bookings_list;
        for (let j = 0; j < list.length; j++) {
          let booking = list[j];
          if (booking.id == element.id) {
            state.bookingsByBus[i].bookings_list.splice(j, 1, element);
          }
        }
      }
    }
  },

  UPDATE_BOOKINGS_BY_STOP: (state, {
    bookingData
  }) => {
    for (let i = 0; i < bookingData.length; i++) {
      const element = bookingData[i];

      for (let i = 0; i < state.bookingsByStop.length; i++) {
        const bookingsByStop = state.bookingsByStop[i];
        let list = bookingsByStop.bookings_list;
        for (let j = 0; j < list.length; j++) {
          let booking = list[j];
          if (booking.id == element.id) {
            state.bookingsByStop[i].bookings_list.splice(j, 1, element);
          }
        }
      }
    }
  },

  RESET_UNASSIGNED_BOOKINGS(state) {
    state.bookingsUnassigned = [];
  },
  RESET_ORPHAN_BOOKINGS(state) {
    state.bookingsOrphanGroup = [];
  },

  DELETE_BOOKING_UNASSIGNED(state, id) {
    let idx = state.bookingsUnassigned.findIndex(booking => booking.id == id);
    state.bookingsUnassigned.splice(idx, 1);
  },

  DELETE_BOOKING_ORPHAN(state, id) {
    let idx = state.bookingsOrphanGroup.findIndex(booking => booking.id == id);
    state.bookingsOrphanGroup.splice(idx, 1);
  },

  RESET_EXCURSION_DATA(state) {
    state.bookingsByActivity = []
    state.bookingsByExcursionBus = []
    state.bookingsByPickupzoneSummary = []
  },
  RESET_PICKUP_DATA(state) {
    state.bookingsByPickupBus = []
    state.bookingsByStop = []
    state.bookingsByPickupzoneSummary = []
  },
  RESET_RETURN_DATA(state) {
    state.bookingsByReturnBus = []
    state.bookingsByStop = []
    state.bookingsByPickupzoneSummary = []
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};